/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  IncomingEventsSortInput,
  useGetIncomingEventsQuery,
  IncomingEvent,
  IncomingEventsFilterInput,
  EventsSortInput,
  IncomingEventsSortFields,
} from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort: IncomingEventsSortInput | EventsSortInput;
  filter?: IncomingEventsFilterInput;
};

export function useGetIncomingEvents({ page, limit, sort, filter }: Props) {
  const sortInput = {
    field: sort.field as IncomingEventsSortFields,
    order: sort.order,
  };

  const { data, loading, error } = useGetIncomingEventsQuery({
    variables: {
      page: Number(page),
      limit: Number(limit),
      sort: sortInput,
      filter,
    },
  });
  const count = data?.incomingEvents.pageInfo?.count ?? 0;

  return {
    data: (data?.incomingEvents?.result ?? []) as IncomingEvent[],
    loading,
    error,
    count,
  } as const;
}
